import React from 'react';
import { Table } from 'react-bootstrap';
import { getRankByNumber } from '../../../utils/utils';


const Headers = () => (
  <thead>
    <tr>
      <th>
        <span>Name</span>
      </th>
      <th className="max-width-300">
        <span>Description</span>
      </th>
      <th>
        <span>Instructor</span>
      </th>
      <th>
        <span>Credits</span>
      </th>
      <th>
        <span>Rank</span>
      </th>
    </tr>
  </thead>
);

const Body = ({ values }) => (
  <tbody>
    {values.map(({ rankCourse, course, preference_class}) => (
      <tr key={course}>
        <td className="find-class-name">{rankCourse.slug}</td>
        <td className="class-desc max-width-300">{rankCourse.longname}</td>
        <td className="class-desc">{rankCourse.instructor}</td>
        <td className="class-desc">{rankCourse.weight}</td>
        <td className="class-desc">{getRankByNumber(preference_class)}</td>
      </tr>
    ))}
  </tbody>
);

const ConfirmRankingTable = ({ values }) => (
  <div className="c-table classes-table">
    <Table condensed hover>
      <Headers />
      <Body values={values} />
    </Table>
  </div>
);

export default ConfirmRankingTable;


// WEBPACK FOOTER //
// ./src/components/rank/ConfirmPage/ConfirmRankingTable.js